import { createContext, useContext } from 'react';
export const FieldActionsContext = createContext({});
export function useFieldActions() {
    return useContext(FieldActionsContext);
}

//# sourceMappingURL=field-actions-context.js.map